export type AppShellRightPanelKind = 'static' | 'component-builder-inspector' | 'website-builder-inspector';

export interface AppShellRightPanelSection {
  title: string;
  description?: string;
  items?: string[];
}

export interface AppShellRightPanelConfig {
  kind?: AppShellRightPanelKind;
  title: string;
  description?: string;
  sections?: AppShellRightPanelSection[];
}

export interface AppShellPageConfig {
  title: string;
  translateTitle?: boolean;
  showUserMenu?: boolean;
  fullWidth?: boolean;
  backLink?: string | null;
  backLabel?: string;
  translateBackLabel?: boolean;
  rightPanel?: AppShellRightPanelConfig | null;
}

export const DEFAULT_APP_SHELL_CONFIG: AppShellPageConfig = {
  title: 'APP_NAME',
  translateTitle: true,
  showUserMenu: true,
  fullWidth: false,
  backLink: null,
  backLabel: 'Back',
  translateBackLabel: false,
  rightPanel: null
};
